'use client'

import { useMediaQuery as useMediaQueryHook } from '@react-hookz/web'
import {
  MediaQueryFromLg,
  MediaQueryFromMd,
  MediaQueryFromSm,
  MediaQueryFromXl,
  MediaQueryFromXs,
  MediaQueryFromXxl,
  MediaQueryFromXxs,
  MediaQueryLgUpToXl,
  MediaQueryLgUpToXxl,
  MediaQueryMdUpToLg,
  MediaQueryMdUpToXl,
  MediaQueryMdUpToXxl,
  MediaQueryOnlyLg,
  MediaQueryOnlyMd,
  MediaQueryOnlySm,
  MediaQueryOnlyXl,
  MediaQueryOnlyXs,
  MediaQueryOnlyXxs,
  MediaQuerySmUpToLg,
  MediaQuerySmUpToMd,
  MediaQuerySmUpToXl,
  MediaQuerySmUpToXxl,
  MediaQueryToLg,
  MediaQueryToMd,
  MediaQueryToSm,
  MediaQueryToXl,
  MediaQueryToXs,
  MediaQueryToXxl,
  MediaQueryXlUpToXxl,
  MediaQueryXsUpToLg,
  MediaQueryXsUpToMd,
  MediaQueryXsUpToSm,
  MediaQueryXsUpToXl,
  MediaQueryXsUpToXxl,
  MediaQueryXxsUpToLg,
  MediaQueryXxsUpToMd,
  MediaQueryXxsUpToSm,
  MediaQueryXxsUpToXl,
  MediaQueryXxsUpToXs,
  MediaQueryXxsUpToXxl,
} from '@snowball-tech/design-tokens'

import isEmpty from 'lodash/fp/isEmpty'

export default function useMediaQuery(customQuery?: string) {
  const fromXxs = useMediaQueryHook(MediaQueryFromXxs)
  const fromXs = useMediaQueryHook(MediaQueryFromXs)
  const fromSm = useMediaQueryHook(MediaQueryFromSm)
  const fromMd = useMediaQueryHook(MediaQueryFromMd)
  const fromLg = useMediaQueryHook(MediaQueryFromLg)
  const fromXl = useMediaQueryHook(MediaQueryFromXl)
  const fromXxl = useMediaQueryHook(MediaQueryFromXxl)

  const onlyXxs = useMediaQueryHook(MediaQueryOnlyXxs)
  const onlyXs = useMediaQueryHook(MediaQueryOnlyXs)
  const onlySm = useMediaQueryHook(MediaQueryOnlySm)
  const onlyMd = useMediaQueryHook(MediaQueryOnlyMd)
  const onlyLg = useMediaQueryHook(MediaQueryOnlyLg)
  const onlyXl = useMediaQueryHook(MediaQueryOnlyXl)
  const onlyXxl = useMediaQueryHook(MediaQueryFromXxl)

  const toXs = useMediaQueryHook(MediaQueryToXs)
  const toSm = useMediaQueryHook(MediaQueryToSm)
  const toMd = useMediaQueryHook(MediaQueryToMd)
  const toLg = useMediaQueryHook(MediaQueryToLg)
  const toXl = useMediaQueryHook(MediaQueryToXl)
  const toXxl = useMediaQueryHook(MediaQueryToXxl)

  const fromXxsToXs = useMediaQueryHook(MediaQueryXxsUpToXs)
  const fromXxsToSm = useMediaQueryHook(MediaQueryXxsUpToSm)
  const fromXxsToMd = useMediaQueryHook(MediaQueryXxsUpToMd)
  const fromXxsToLg = useMediaQueryHook(MediaQueryXxsUpToLg)
  const fromXxsToXl = useMediaQueryHook(MediaQueryXxsUpToXl)
  const fromXxsToXxl = useMediaQueryHook(MediaQueryXxsUpToXxl)
  const fromXsToSm = useMediaQueryHook(MediaQueryXsUpToSm)
  const fromXsToMd = useMediaQueryHook(MediaQueryXsUpToMd)
  const fromXsToLg = useMediaQueryHook(MediaQueryXsUpToLg)
  const fromXsToXl = useMediaQueryHook(MediaQueryXsUpToXl)
  const fromXsToXxl = useMediaQueryHook(MediaQueryXsUpToXxl)
  const fromSmToMd = useMediaQueryHook(MediaQuerySmUpToMd)
  const fromSmToLg = useMediaQueryHook(MediaQuerySmUpToLg)
  const fromSmToXl = useMediaQueryHook(MediaQuerySmUpToXl)
  const fromSmToXxl = useMediaQueryHook(MediaQuerySmUpToXxl)
  const fromMdToLg = useMediaQueryHook(MediaQueryMdUpToLg)
  const fromMdToXl = useMediaQueryHook(MediaQueryMdUpToXl)
  const fromMdToXxl = useMediaQueryHook(MediaQueryMdUpToXxl)
  const fromLgToXl = useMediaQueryHook(MediaQueryLgUpToXl)
  const fromLgToXxl = useMediaQueryHook(MediaQueryLgUpToXxl)
  const fromXlToXxl = useMediaQueryHook(MediaQueryXlUpToXxl)

  const isCustom = useMediaQueryHook(customQuery ?? '')

  return {
    isCustom: isEmpty(customQuery) ? undefined : isCustom,

    /* eslint-disable perfectionist/sort-objects */
    isXxs: onlyXxs,
    isXs: onlyXs,
    isSm: onlySm,
    isMd: onlyMd,
    isLg: onlyLg,
    isXl: onlyXl,
    isXxl: onlyXxl,
    /* eslint-enable perfectionist/sort-objects */

    /* eslint-disable perfectionist/sort-objects */
    fromXxs,
    fromXs,
    fromSm,
    fromMd,
    fromLg,
    fromXl,
    fromXxl,
    /* eslint-enable perfectionist/sort-objects */

    /* eslint-disable perfectionist/sort-objects */
    toXs,
    toSm,
    toMd,
    toLg,
    toXl,
    toXxl,
    /* eslint-enable perfectionist/sort-objects */

    /* eslint-disable perfectionist/sort-objects */
    fromXxsToXs,
    fromXxsToSm,
    fromXxsToMd,
    fromXxsToLg,
    fromXxsToXl,
    fromXxsToXxl,
    fromXsToSm,
    fromXsToMd,
    fromXsToLg,
    fromXsToXl,
    fromXsToXxl,
    fromSmToMd,
    fromSmToLg,
    fromSmToXl,
    fromSmToXxl,
    fromMdToLg,
    fromMdToXl,
    fromMdToXxl,
    fromLgToXl,
    fromLgToXxl,
    fromXlToXxl,
    /* eslint-enable perfectionist/sort-objects */
  }
}
